import { render, staticRenderFns } from "./timeSlotCard.vue?vue&type=template&id=44afe019"
import script from "./timeSlotCard.vue?vue&type=script&lang=js"
export * from "./timeSlotCard.vue?vue&type=script&lang=js"
import style0 from "./timeSlotCard.vue?vue&type=style&index=0&id=44afe019&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports